export default {
  formMetaData: {},
  formFileToUpload: null,
  formFileToDelete: null
}
